import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProductDetailFetchSuccess,
    getProductDetailFetchFailure,
    getProductDetailChangelogFetchSuccess,
    getProductDetailChangelogFetchFailure,
    getProductDetailStockFetchSuccess,
    getProductDetailStockFetchFailure,
    getProductDetailOrdersFetchSuccess,
    getProductDetailOrdersFetchFailure,
    getProductDetailStockMovementsFetchSuccess,
    getProductDetailStockMovementsFetchFailure,
    getProductDetailProductReceivingsFetchSuccess,
    getProductDetailProductReceivingsFetchFailure,
    getProductDetailProductOrdersGridFetchSuccess,
    getProductDetailProductOrdersGridFetchFailure,
    getProductDetailProductReturnsFetchSuccess,
    getProductDetailProductReturnsFetchFailure,
    createProductDetailFetchSuccess,
    createProductDetailFetchFailure,
    updateProductDetailFetchSuccess,
    updateProductDetailFetchFailure,
    deleteProductFetchSuccess,
    deleteProductFetchFailure,
    activateProductFetchSuccess,
    activateProductFetchFailure,
    deactivateProductFetchSuccess,
    deactivateProductFetchFailure,
} from './reducer';
import {
    ProductDetailOrdersResType,
    ProductDetailProductReceivingsResType,
    ProductDetailProductOrdersResType,
    ProductDetailProductReturnsResType,
    ProductDetailResType,
    ProductDetailStockResType,
    ProductDetailStockMovementsResType,
} from 'src/types/productDetail';
import { GridRequestType } from 'src/types/table';
import { ProductType } from 'src/types/product';
import translate from '@translate';
import moment from 'moment';

const getProductDetailFetchRequest = async (idProduct: string) => {
    const res = await api('get', `api/secure/products/${idProduct}`);
    return res.data;
};

function* getProductDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailResType = yield call((): any => getProductDetailFetchRequest(action.payload));
        yield put(getProductDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailFetchFailure({ error }));
    }
}

export function* getProductDetailFetchWatch() {
    yield takeEvery('productDetail/getProductDetailFetch', getProductDetailFetch);
}

const getProductDetailStockFetchRequest = async (idProduct: string) => {
    const res = await api('get', `api/secure/products/${idProduct}/all-stock`);
    return res.data;
};

function* getProductDetailStockFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailStockResType = yield call((): any =>
            getProductDetailStockFetchRequest(action.payload)
        );
        yield put(getProductDetailStockFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailStockFetchFailure({ error }));
    }
}

export function* getProductDetailStockFetchWatch() {
    yield takeEvery('productDetail/getProductDetailStockFetch', getProductDetailStockFetch);
}

const getProductDetailOrdersFetchRequest = async (params: { idProduct: string; timeFrom: moment.Moment }) => {
    const res = await api(
        'get',
        `api/secure/products/${params.idProduct}/orders?timeFrom=${params.timeFrom.toISOString()}`
    );
    return res.data;
};

function* getProductDetailOrdersFetch(action: {
    type: string;
    payload: { idProduct: string; timeFrom: moment.Moment };
}) {
    try {
        const response: ProductDetailOrdersResType = yield call((): any =>
            getProductDetailOrdersFetchRequest(action.payload)
        );
        yield put(getProductDetailOrdersFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailOrdersFetchFailure({ error }));
    }
}

export function* getProductDetailOrdersFetchWatch() {
    yield takeEvery('productDetail/getProductDetailOrdersFetch', getProductDetailOrdersFetch);
}

const getProductDetailStockMovementsFetchRequest = async (params: {
    idProduct: string;
    gridPayload: GridRequestType;
}) => {
    const res = await api('post', 'api/secure/stock-movements/grid', params.gridPayload);
    return res.data;
};

function* getProductDetailStockMovementsFetch(action: {
    type: string;
    payload: { idProduct: string; gridPayload: GridRequestType };
}) {
    try {
        const response: ProductDetailStockMovementsResType = yield call((): any =>
            getProductDetailStockMovementsFetchRequest(action.payload)
        );
        yield put(getProductDetailStockMovementsFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailStockMovementsFetchFailure({ error }));
    }
}

export function* getProductDetailStockMovementsFetchWatch() {
    yield takeEvery('productDetail/getProductDetailStockMovementsFetch', getProductDetailStockMovementsFetch);
}

const getProductDetailProductReceivingsFetchRequest = async (params: {
    idProduct: string;
    gridPayload: GridRequestType;
}) => {
    const res = await api('post', `api/secure/products/${params.idProduct}/receivings/grid`, params.gridPayload);
    return res.data;
};

function* getProductDetailProductReceivingsFetch(action: {
    type: string;
    payload: { idProduct: string; gridPayload: GridRequestType };
}) {
    try {
        const response: ProductDetailProductReceivingsResType = yield call((): any =>
            getProductDetailProductReceivingsFetchRequest(action.payload)
        );
        yield put(getProductDetailProductReceivingsFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailProductReceivingsFetchFailure({ error }));
    }
}

export function* getProductDetailProductReceivingsFetchWatch() {
    yield takeEvery('productDetail/getProductDetailProductReceivingsFetch', getProductDetailProductReceivingsFetch);
}

const getProductDetailProductOrdersGridFetchRequest = async (params: {
    idProduct: string;
    gridPayload: GridRequestType;
}) => {
    const res = await api('post', `api/secure/products/${params.idProduct}/orders/grid`, params.gridPayload);
    return res.data;
};

function* getProductDetailProductOrdersGridFetch(action: {
    type: string;
    payload: { idProduct: string; gridPayload: GridRequestType };
}) {
    try {
        const response: ProductDetailProductOrdersResType = yield call((): any =>
            getProductDetailProductOrdersGridFetchRequest(action.payload)
        );
        yield put(getProductDetailProductOrdersGridFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailProductOrdersGridFetchFailure({ error }));
    }
}

export function* getProductDetailProductOrdersGridFetchWatch() {
    yield takeEvery('productDetail/getProductDetailProductOrdersGridFetch', getProductDetailProductOrdersGridFetch);
}

const getProductDetailProductReturnsFetchRequest = async (params: {
    idProduct: string;
    gridPayload: GridRequestType;
}) => {
    const res = await api('post', `api/secure/products/${params.idProduct}/returns/grid`, params.gridPayload);
    return res.data;
};

function* getProductDetailProductReturnsFetch(action: {
    type: string;
    payload: { idProduct: string; gridPayload: GridRequestType };
}) {
    try {
        const response: ProductDetailProductReturnsResType = yield call((): any =>
            getProductDetailProductReturnsFetchRequest(action.payload)
        );
        yield put(getProductDetailProductReturnsFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailProductReturnsFetchFailure({ error }));
    }
}

export function* getProductDetailProductReturnsFetchWatch() {
    yield takeEvery('productDetail/getProductDetailProductReturnsFetch', getProductDetailProductReturnsFetch);
}

const createProductDetailFetchRequest = async (data: ProductType) => {
    const res = await api('post', 'api/secure/products', data);
    return res.data;
};

function* createProductDetailFetch(action: { type: string; payload: ProductType }) {
    try {
        const response: ProductDetailResType = yield call((): any => createProductDetailFetchRequest(action.payload));
        yield put(
            createProductDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('products.message.productCreated') },
            })
        );
    } catch (error) {
        yield put(createProductDetailFetchFailure({ error }));
    }
}

export function* createProductDetailFetchWatch() {
    yield takeEvery('productDetail/createProductDetailFetch', createProductDetailFetch);
}

const updateProductDetailFetchRequest = async (params: {
    idProduct: string;
    data: ProductType;
    updateOrders?: boolean;
}) => {
    const query = params.updateOrders ? '?updateOrders=true' : '';
    const res = await api('put', `api/secure/products/${params.idProduct}${query}`, params.data);
    return res.data;
};

function* updateProductDetailFetch(action: {
    type: string;
    payload: { idProduct: string; data: ProductType; updateOrders?: boolean };
}) {
    try {
        const response: ProductDetailResType = yield call((): any => updateProductDetailFetchRequest(action.payload));
        yield put(
            updateProductDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('products.message.productUpdate') },
            })
        );
    } catch (error) {
        yield put(updateProductDetailFetchFailure({ error }));
    }
}

export function* updateProductDetailFetchWatch() {
    yield takeEvery('productDetail/updateProductDetailFetch', updateProductDetailFetch);
}

const deleteProductFetchRequest = async (idProduct: string) => {
    const res = await api('delete', `api/secure/products/${idProduct}`);
    return res.data;
};

function* deleteProductFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailResType = yield call((): any => deleteProductFetchRequest(action.payload));
        yield put(
            deleteProductFetchSuccess({
                ...response,
                messageSuccess: { title: translate('products.message.productDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteProductFetchFailure({ error }));
    }
}

export function* deleteProductFetchWatch() {
    yield takeEvery('productDetail/deleteProductFetch', deleteProductFetch);
}

const activateProductFetchRequest = async (idProduct: string) => {
    const res = await api('put', `api/secure/products/${idProduct}/activate`);
    return res.data;
};

export function* activateProductFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailResType = yield call((): any => activateProductFetchRequest(action.payload));
        yield put(
            activateProductFetchSuccess({
                ...response,
                messageSuccess: { title: translate('products.message.productActivated') },
            })
        );
    } catch (error) {
        yield put(activateProductFetchFailure({ error }));
    }
}

export function* activateProductFetchWatch() {
    yield takeEvery('productDetail/activateProductFetch', activateProductFetch);
}

const deactivateProductFetchRequest = async (idProduct: string) => {
    const res = await api('put', `api/secure/products/${idProduct}/deactivate`);
    return res.data;
};

export function* deactivateProductFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailResType = yield call((): any => deactivateProductFetchRequest(action.payload));
        yield put(
            deactivateProductFetchSuccess({
                ...response,
                messageSuccess: { title: translate('products.message.productDeactivated') },
            })
        );
    } catch (error) {
        yield put(deactivateProductFetchFailure({ error }));
    }
}

export function* deactivateProductFetchWatch() {
    yield takeEvery('productDetail/deactivateProductFetch', deactivateProductFetch);
}

const getProductDetailChangelogFetchRequest = async (idProduct: string) => {
    const res = await api('get', `api/secure/products/changelog/${idProduct}`);
    return res.data;
};

function* getProductDetailChangelogFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductDetailResType = yield call((): any =>
            getProductDetailChangelogFetchRequest(action.payload)
        );
        yield put(getProductDetailChangelogFetchSuccess(response));
    } catch (error) {
        yield put(getProductDetailChangelogFetchFailure({ error }));
    }
}

export function* getProductDetailChangelogFetchWatch() {
    yield takeEvery('productDetail/getProductDetailChangelogFetch', getProductDetailChangelogFetch);
}
